import { useQuery } from '@apollo/client/react';
import { DimeSpinner } from '@nudool/design-system';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useBreadcrumbLabel } from '../../components/BreadcrumbLabelsContext.js';
import { assertUuidRouteParams } from '../../lib/assert-uuid-route-params.js';
import {
  GET_ROLE,
  type GetRoleQueryResult,
  type GetRoleQueryVariables,
} from '../../modules/roles/operations.js';
import { RoleDetailView } from '../../modules/roles/role-detail.js';

export const Route = createFileRoute('/roles/$roleId')({
  beforeLoad: ({ params }) => assertUuidRouteParams(params),
  validateSearch: (search: Record<string, unknown>) => ({
    edit: search.edit === true || search.edit === 'true',
  }),
  component: SetupRoleDetailPage,
});

// eslint-disable-next-line react-refresh/only-export-components
function SetupRoleDetailPage() {
  const navigate = useNavigate();
  const { roleId } = Route.useParams();
  const { edit: startEditing } = Route.useSearch();
  const { data, loading, refetch } = useQuery<GetRoleQueryResult, GetRoleQueryVariables>(GET_ROLE, {
    variables: { id: roleId },
  });

  const role = data?.userGroup;
  useBreadcrumbLabel(roleId, role?.name);

  const setEditingInUrl = (editing: boolean) => {
    void navigate({
      to: '/roles/$roleId',
      params: { roleId },
      search: { edit: editing },
      replace: true,
    });
  };

  return (
    <div>
      {loading && !data ? (
        <div className="flex items-center gap-2 text-sm text-muted-foreground">
          <DimeSpinner />
          Loading…
        </div>
      ) : !role ? (
        <div className="text-sm text-muted-foreground">Role not found.</div>
      ) : (
        <RoleDetailView
          role={role}
          initialEditing={startEditing}
          onChanged={() => void refetch()}
          onEditingChange={setEditingInUrl}
        />
      )}
    </div>
  );
}
